<template>
  <!-- 资质证书 -->
  <div class="credentialPage">
    <div v-if="!this.showLoad">
      <p class="fgx"></p>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.certificateTitle"
          label="证书名称"
          :required="editType"
          :readonly="!editType"
          class="ggInput"
          :placeholder="editType ? '请输入...  ' : ''"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.specialty"
          label="专业"
          :readonly="!editType"
          class="ggInput"
          :placeholder="editType ? '请输入...  ' : ''"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.certificateNumber"
          label="证书编号"
          :required="editType"
          :readonly="!editType"
          class="ggInput"
          :placeholder="editType ? '请输入...  ' : ''"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          label="证书类型"
          :required="editType"
          readonly
          v-model="certificateType"
          @click="changeCredentialTypePicker"
          :is-link="editType"
          class="ggInput"
          :placeholder="editType ? '请选择' : ''"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          readonly
          label="证书级别"
          :required="editType"
          v-model="certificateLevel"
          @click="changeCredentialGradePicker"
          :is-link="editType"
          class="ggInput"
          :placeholder="editType ? '请选择' : ''"
        />
      </van-cell-group>

      <van-cell-group class="baseNone baseSalary">
        <van-field
          label="发放日期"
          readonly
          v-model="baseData.grantingDate"
          :required="editType"
          @click="TimePicker(1)"
          :is-link="editType"
          :placeholder="editType ? '请选择' : ''"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          label="到期日期"
          readonly
          v-model="baseData.expirationDate"
          @click="TimePicker(2)"
          :is-link="editType"
          :placeholder="editType ? '请选择' : ''"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary summaryBox beizhu">
        <!-- <p>备注：</p> -->
        <van-field
          label="备注："
          v-model="baseData.remarks"
          rows="1"
          autosize
          :readonly="!editType"
          type="textarea"
          :placeholder="editType ? '请输入...  ' : ''"
          class="minRows"
        />
      </van-cell-group>
      <!-- 附件 -->
      <!-- 微信的附件 避免和原生交互 -->
      <wx-file-view
        v-if="is_weixn"
        :filesData="baseData"
        :editType="editType"
        class="fileview"
      ></wx-file-view>
      <!-- 原生附件 -->
      <file-view
        v-else
        :filesData="baseData"
        :editType="editType"
        @changeFile="changebaseAnnexes"
        class="fileview"
      ></file-view>

      <div class="btnBox" v-if="this.commonType == 'add'">
        <a href="javascript:void(0);" class="btn" @click="checkInput">保存</a>
      </div>
      <div
        class="btnBox editBtnbox clearfix"
        v-if="this.commonType == 'edit' && this.editType == true"
      >
        <a href="javascript:void(0);" class="btn fl" @click="delApply">删除</a>

        <a href="javascript:void(0);" class="btn fr" @click="checkInput"
          >保存</a
        >
      </div>
      <!-- 弹框 -->

      <!-- 证书类型弹框 -->
      <van-popup v-model="showCredentialTypePicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="credentialTypeList"
          value-key="dictName"
          @cancel="showCredentialTypePicker = false"
          @confirm="saveCredentialType"
        />
      </van-popup>
      <!-- 证书级别弹框 -->
      <van-popup v-model="showCredentialGradePicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="credentialGradeList"
          value-key="dictName"
          @cancel="showCredentialGradePicker = false"
          @confirm="saveCredentialGrade"
        />
      </van-popup>

      <!-- 时间控件 -->
      <van-popup v-model="showTimePicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          @cancel="showTimePicker = false"
          @confirm="onTimeConfirm"
          :min-date="minDate"
        />
      </van-popup>
      <refresh-page v-if="refreshPage" />
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { mapState, mapMutations } from "vuex";
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
const refreshPage = () => import("@/components/common/refreshPage");
import { dateFormat, getDictList } from "@/utils/common";
import { getDeviceType,is_wei } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "credential",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      mode: "", //是编辑还是新增
      commonType: "", // 返回当前表单时 add/新增 ？ edit/查看,编辑？
      commonId: "", //编辑Id
      editType: false, //当前表单是否可以编辑
      certificateLevel: "", //证书等级
      certificateType: "", //证书类型
      baseData: {
        certificateLevel: "",
        certificateNumber: "",
        certificateTitle: "",
        certificateType: "",
        grantingDate: "",
        baseAnnexes: [],
        expirationDate: "",
        remarks: "",
        specialty: "",
        uid: "",
      }, //信息储存集
      showCredentialGradePicker: false, //证书级别弹框
      credentialGradeList: [], //证书级别列表
      showCredentialTypePicker: false, //证书类型弹框
      credentialTypeList: [], //证书类型列表
      showTimePicker: false, //时间控件
      currentDate: new Date(), //当前时间
      minDate: new Date(2000, 1, 1),
      checkIndex: "", // 获取证书发放和到期时间
      refreshPage: false, // 网络请求失败时显示
      clientType: getDeviceType(), //手机类型
      addType: false, //防止高频点击
      is_weixn: is_wei(), //是否为微信
    };
  },
  mounted() {
    this.commonType = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.commonId = this.$route.query.commonId; //证书Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    window.editPage = this.editPage; //编辑页面
    window.setFile = this.setFiles; //app返回附件回调
    this.$nextTick(() => {
      this.baseData.uid = this.userinfo.id;
      this.getDictList();
      if (this.commonType == "edit") {
        this.initPage();
      } else {
        this.setShowLoad(false);
        this.editType = true;
      }
    });
  },
  components: {
    refreshPage,
    fileView,
    wxFileView,
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    initPage() {
      let _this = this;
      _this.$api.userCenter.user.myInfo
        .getCertificateDetail(_this.commonId)
        .then((res) => {
          if (res.code == "1") {
            _this.setShowLoad(false);
            _this.baseData = Object.assign({}, _this.baseData, res.data);
            _this.certificateLevel = _this.baseData.certificateLevelName;
            _this.certificateType = _this.baseData.certificateTypeName;
            _this.editPage();
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    editPage() {
      //点击编辑页面
      this.editType = true;
    },
    async getDictList() {
      let _this = this;
      _this.credentialGradeList = await getDictList("zhengshujibie");
      _this.credentialTypeList = await getDictList("zhengshuleixin");
    },
    saveCredentialType(data) {
      //选择证书类型
      this.showCredentialTypePicker = false;
      this.baseData.certificateType = data.dictCode;
      this.certificateType = data.dictName;
    },
    saveCredentialGrade(data) {
      //选择证书等级
      this.showCredentialGradePicker = false;
      this.baseData.certificateLevel = data.dictCode;
      this.certificateLevel = data.dictName;
    },
    changeCredentialTypePicker() {
      //判断当前是否编辑状态
      if (this.editType) {
        this.showCredentialTypePicker = true;
      }
    },
    changeCredentialGradePicker() {
      //判断当前是否编辑状态
      if (this.editType) {
        this.showCredentialGradePicker = true;
      }
    },
    TimePicker(type) {
      if (!this.editType) {
        this.showTimePicker = false;
        return;
      }
      this.checkIndex = type;
      this.showTimePicker = true;
    },
    onTimeConfirm(data) {
      this.showTimePicker = false;
      if (this.checkIndex == "1") {
        this.baseData.grantingDate = dateFormat(data);
      } else {
        this.baseData.expirationDate = dateFormat(data);
      }
    },
    //监测附件方法
    changebaseAnnexes(data) {
      this.baseData.baseAnnexes = data;
    },
    backPage() {
      if (this.clientType == "android") {
        window.android.getInfo(103);
      } else {
        //IOS
        window.webkit.messageHandlers.closePage.postMessage("1");
      }
    },
    delApply() {
      //删除资质证书记录
      let _this = this;
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否删除资质证书",
        })
        .then(() => {
          _this.$api.userCenter.user.myInfo
            .deleteCertificate(_this.commonId)
            .then((res) => {
              if (res.code == "1") {
                _this.$toast("资质证书删除成功！");
                setTimeout(function () {
                  console.log("关闭页面");
                  this.backPage();
                }, 3000);
              } else {
                _this.$toast(res.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          // 取消删除操作
        });
    },

    checkInput() {
      let _this = this;
      if (_this.addType == true) {
        _this.$toast("请不要频繁提交！");
      } else {
        _this.addType = true;
        if (
          _this.baseData.certificateLevel == "" ||
          _this.baseData.certificateNumber == "" ||
          _this.baseData.certificateTitle == "" ||
          _this.baseData.certificateType == "" ||
          _this.baseData.grantingDate == ""
        ) {
          _this.$toast("带星号为必填项，不能为空！");
          _this.addType = false;
        } else {
          _this.saveCredentialBox();
        }
      }
    },
    //保存资质证书
    saveCredentialBox() {
      let _this = this;
      _this.addType = false;
      if (_this.baseData.baseAnnexes != null) {
        if (_this.baseData.baseAnnexes.length < 1) {
          _this.baseData.baseAnnexes = null;
        }
      }
      _this.$api.userCenter.user.myInfo
        .saveCertificate(_this.mode, _this.baseData)
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.$toast(res.msg);
            if (_this.mode == "add") {
              _this.$toast("新增证书成功");
            } else {
              _this.$toast("修改证书成功");
            }
            setTimeout(function () {
              _this.addType = false;
              _this.backPage();
            }, 3000);
          } else {
            console.log(res.msg);
            _this.addType = false;
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.credentialPage {
  width: 100%;
  min-height: 100%;
  background-color: #f6f6f6;
  .fgx {
    width: 100%;
    height: 12px;
    background-color: #f6f6f6;
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
    border-bottom: 1px solid #f6f6f6;
  }
  .baseNone.van-hairline--top-bottom::after {
    border-width: 0;
  }
  .summaryBox {
    .minRows.van-cell {
      overflow: initial;
      .van-field__body {
        textarea {
          min-height: 27px;
          text-align: right;
        }
      }
    }
  }
  .accessoryBox {
    p {
      padding: 0 16px;
      font-size: 14px;
      height: 45px;
      line-height: 45px;
      position: relative;
      a.recordImg {
        display: inline-block;
        position: absolute;
        top: 0;
        right: 15px;
        color: #3c78f9;
      }
    }
    .detailMian {
      padding: 0 16px;
      width: 100%;
      margin-top: 10px;

      li {
        width: 100%;
        min-height: 40px;
        margin: 10px 0;

        dl {
          width: 85%;
          position: relative;

          dt {
            display: block;
            width: 40px;
            height: 40px;
            background-color: #f6f6f6;
            position: absolute;
            img {
              width: 100%;
              height: 100%;
            }
          }

          dd {
            display: block;
            font-size: 10px;
            color: #999;
            position: absolute;
          }

          dd.dtName {
            font-size: 12px;
            color: #666;
            top: 0px;
            left: 50px;
          }
          dd.Mb {
            top: 17px;
            left: 50px;
          }
        }
      }

      a {
        display: block;
        font-size: 12px;
        color: #35c476;
        width: 30px;
        height: 30px;
        line-height: 30px;
      }
      a.delBtn {
        color: #f34646;
      }
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    .btn {
      display: block;
      width: 100%;
      height: 45px;
      line-height: 45px;
      text-align: center;
      background-color: #3c78f9;
      color: #fff;
      font-size: 16px;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
    }
  }
  .editBtnbox.btnBox {
    .btn {
      width: 40%;
    }
    .btn:first-child {
      background-color: #f34646;
    }
  }
}
</style>